<div class="loader">
  <div class="wiper"></div>
</div>
